<template lang="pug">
section
  .overlay
  header.d-flex.row.flex-row.align-items-end.justify-content-center.mb-5
    .col-12
      .absolute-right
      horizontal-stepper.mt-3(:steps='steps', :keep-alive="false", @completed-step='completeStep', locale='es', @active-step='isStepActive', @stepper-finished='finishPlan()')
  b-modal(:id='infoModal.id', centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
      <template v-slot:modal-title>
        h3.font-weight-bold.mb-0 {{infoModal.title}}
      </template>
      p.text-center {{ infoModal.content }}
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        .col-12.d-flex.justify-content-around
            b-button.px-4(size="lg", variant="danger", @click="closePopCPM()")
              | Mas tarde
            b-button.px-4(size="lg", variant="outline-secondary", @click="goToCPM()")
              | Ir ahora
      </template>

</template>

<script>
import HorizontalStepper from 'vue-stepper'
import { mapActions } from 'vuex'
import moment from 'moment'

import Pendientes from './ps-pendientes.vue'
import Objetivos from './ps-objetivos.vue'
import ObjetivosGerente from './ps-objetivos-ge.vue'
import DialogosDeDesempeno from './ps-ddd.vue'
import SeguimientoDiario from './ps-seguimiento.vue'
import DesarrolloPersonal from './ps-desarrollo.vue'
import Cierre from './ps-cierre.vue'

export default {

  name: 'PlanificacionSemanal',
  components: {
      HorizontalStepper
  },

  data () {
    return {
      overlay: this.overlay,
      plan: null,
      user: {},
      businesstypes: [],
      lastWeekObjectives: [],
      CPM: 0,    
      managments: [],      
      steps: [
          {
              icon: 'mail',
              name: 'pendientes',
              title: 'Pendientes',
              component: Pendientes,
              completed: false,
          },
          {
              icon: '',
              name: 'objetivos',
              title: 'Objetivos',
              component: Objetivos,
              completed: false,
          },
          {
              icon: '',
              name: 'ddd',
              title: 'Diálogos de desempeño',
              component: DialogosDeDesempeno,
              completed: false,
          },
          {
              icon: '',
              name: 'cpsd',
              title: 'C.P/S.D',
              component: SeguimientoDiario,
              completed: false,
          },
          {
              icon: '',
              name: 'desarrollopersonal',
              title: 'Desarrollo Personal',
              component: DesarrolloPersonal,
              completed: false,
          },
          {
              icon: '',
              name: 'cierre',
              title: 'Cierre',
              component: Cierre,
              completed: false,
          }
      ],
      infoModal: {
        id: 'cpm',
        title: '¡Atención!',
        content: 'Recuerda que debes realizar un CP mensual'
      }
    }
  },
  methods: {
    moment,
    ...mapActions('plan', [
      'planById', 'planUpdate', 'create', 'planByWeek', 'closePlanificationStage'
    ]),
    ...mapActions('businesstype', [
      'businessTypeList'
    ]),
    ...mapActions('managment', [
      'managmentList'
    ]),
    ...mapActions('travel', [
      'travelList'
    ]),
    ...mapActions('kpi', [
      'kpiList'
    ]),
    ...mapActions('objective', [
      'getObjectiveByWeek', 'getObjectiveByLastWeek', 'getObjectiveByPlan', 'getObjectiveOpenLastWeek'
    ]),
    ...mapActions('user', [
      'myTeam'    
    ]),
    ...mapActions('auth', [
      
    ]),
    ...mapActions('monthlypc', [
      'haveOpenCPMs'
    ]),
    // Executed when @completed-step event is triggered
    completeStep(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                step.completed = true;
                document.querySelector('.step-title').classList.add('state-past');
            }
        })
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
        this.steps.forEach((step) => {
            if (step.name === payload.name) {
                if(step.completed === true) {
                    step.completed = false;
                }
            }
        })
    },
    // Executed when @stepper-finished event is triggered
    finishPlan(payload) {
      const vm = this      
      const loading = vm.$toast.loading('Cerrando plan...')
      vm.closePlanificationStage({id: vm.plan._id, user: vm.user.id}).then(result => {
        vm.plan = vm.$store.getters['plan/getPlan']
          if (result.success) {
            this.$root.$emit('hidePlanification', 'hide');
            setTimeout(() => {
              this.$router.push('/home')
              loading.hide()
            }, 3000)        
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Plan cerrado',
              closeable: true,
              duration: 5000
            })
          }
      }).catch(err => {
        console.log(err)
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: err.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    loadPlan() {
      const vm = this
      const loading = vm.$toast.loading('Cargando Plan...')
      vm.planByWeek({date: new Date(moment().utc()), id: vm.user.id}).then(() => {        
        vm.plan = vm.$store.getters['plan/getPlan']
        if (vm.plan) {
          loading.hide()
          if (vm.plan.state.order == 1) {
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: 'Ya tienes una planificacion abierta',
              closeable: true,
              duration: 5000
            })
            this.$router.push('/home')
          }
          vm.loadLastWeekObjectives()
        } else {                    
          vm.createPlan().then(() => {
            loading.hide()
           vm.loadLastWeekObjectives() 
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error.payload.message,
              closeable: true,
              duration: 5000
            })
          })          
        }
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    createPlan() {
      return new Promise((resolve, reject) => {
        const vm = this
        let currentWeek = moment().isoWeek()
        vm.create({name: `Plan semana ${currentWeek}`, user: vm.user.id}).then(() => {         
          vm.plan = vm.$store.getters['plan/getPlan']
          resolve()
        }, (error) => {
          reject(error)
        })
      })
    },
    update () {
      const vm = this
      vm.planUpdate(vm.plan).then(() => {
        vm.plan = vm.$store.getters['plan/getPlan']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    loadLastWeekObjectives() {
      const vm = this
      vm.getObjectiveOpenLastWeek({date: Date.now(), id: vm.user.id, plan: vm.plan._id}).then(() => {
        vm.lastWeekObjectives = vm.$store.getters['objective/getLWObjectives']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    _objectivesProfile() {
      const vm = this;
      for (let index in vm.steps) {
        if (vm.steps[index].name == 'objetivos') {
          vm.steps[index].component = ObjetivosGerente
        }
      }
    }
    ,
    showPopUpCPM() {
      const vm = this;
      let showcpm = vm.$store.getters['auth/getPopCPM'];
      if (showcpm && vm.CPM == 0) {
        vm.$bvModal.show(vm.infoModal.id)
        vm.$store.dispatch('auth/setShowCPM');
      }
    },
    goToCPM() {
      const vm = this;
      vm.$router.push({name: 'Confirmación de Procesos Mensual'});
    },
    closePopCPM() {
      const vm = this;
      vm.$bvModal.hide(vm.infoModal.id);
    }
  },
  mounted () {
    //user info
    const vm = this    
    const loadingc = vm.$toast.loading('Cargando Datos...')
    vm.user = vm.$store.getters['auth/getUserInfo']      
    if (!vm.$store.getters['auth/canAccessTab']('planificacion_semanal')) {    
      vm.$router.replace({ path: '/permission' })       
    } 
    if (vm.user.profile.auth.tabs.indexOf("confirmacion_procesos") == -1 && vm.user.profile.auth.tabs.indexOf("seguimiento_diario") == -1) {
        vm.steps = vm.steps.filter(step => step['name'] !== 'cpsd')
    } else if(vm.user.profile.auth.tabs.indexOf("confirmacion_procesos") != -1) {
        vm.title = 'Confirmación de Procesos'
        vm.short_title = 'CP'           
    } else {
        vm.title = 'Seguimiento Diario'   
        vm.short_title = 'SD'           
    }
    if (vm.user.profile.name == "Gerente" || vm.user.profile.name == "Subgerente") {
      vm._objectivesProfile()
    }
    vm.myTeam(vm.user.id).then(() => {
      vm.travelList({ids: vm.user.travel}).then(() => {
        vm.managmentList().then(() => {
          vm.managments = vm.$store.getters['managment/getManagments']
          vm.loadPlan();       
          loadingc.hide();
          if (vm.user.profile.suggested_mcp > 0) {
            vm.haveOpenCPMs({userLeader: vm.user.id}).then((cpms) => {
              vm.CPM = cpms;
              vm.showPopUpCPM();
            }, (error) => {
              vm.$notify({
                type: 'danger',
                title: 'Notificación',
                content: error.payload.message,
                closeable: true,
                duration: 5000
              })
            });
          }
        }, (error) => {
          loadingc.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }, (error) => {
        loadingc.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      }) 
    }, (error) => {
      loadingc.hide()
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })          
  },
  computed: {
   alerts(){ 
    return data
   }
  }
};
</script>
<style lang="stylus">
</style>


// WEBPACK FOOTER //
// src/views/planificacion-semanal.vue